import React from 'react';
import PropTypes from 'prop-types';
import './progressBar.scss';
const ProgressBar = ({ value, children }) => {
  return (
    <div className="py-2 text-start progress-container ">
      {children}
      <div className="progress ">
        <div
          className="progress-bar progress-bar-striped progress-bar-animated"
          style={{ width: `${value}%` }}
          role="progressbar"
          aria-valuenow={value}
          aria-valuemin="0"
          aria-valuemax="100"
        />
      </div>
    </div>
  );
};
ProgressBar.propTypes = {
  children: PropTypes.node,
  value: PropTypes.string,
};
ProgressBar.defaultProps = {
  children: null,
  value: '75',
};
export default ProgressBar;
